import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { AnimationInputData } from './useGetLatestAnimations';

export interface CreateAnimationPayload {
  title: string;
  description?: string;
}

const useCreateAnimation = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const createAnimation = useCallback(
    async (payload: CreateAnimationPayload): Promise<AnimationInputData | null> => {
      if (!isReady) return null;
      setIsLoading(true);
      setError('');
      try {
        const result: AnimationInputData = await authFetch('/animation_inputs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/ld+json',
            Accept: 'application/ld+json',
          },
          body: JSON.stringify(payload),
        });
        return result;
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : 'Erreur lors de la création de l\'animation');
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [authFetch, isReady]
  );

  return { createAnimation, isLoading, error };
};

export default useCreateAnimation;
